import React, { useEffect } from 'react'
import { SafeArea } from 'antd-mobile'
// import { debounce } from 'lodash'
import debounce from 'lodash/debounce';

import './index.less'
export default function PopupContent({ children }) {

    const calculatePageHeight = () => {
        const height = window.innerHeight
        console.log('resize', height, '=====////resize/////')
        document.querySelector('.jm-popup-wrapper').style.height = height + 'px'
    }
    useEffect(() => {
        calculatePageHeight(); // 初始计算

        const handleResize = debounce(calculatePageHeight, 100);
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <div className='jm-popup-wrapper' style={{ height: '100vh' }} >
            <SafeArea position='top' />
            <div className='jm-popup-main'>
                {children}
            </div>
            <SafeArea position='bottom' />
        </div>
    )
}
